/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 8/4/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */

export default function(value, placeholder) {
  let json = value?.toString();
  if (json && json.startsWith("[") && json.endsWith("]")) {
    try {
      let path = JSON.parse(json);
      return path.length ? `/${path.join("/")}/` : "/";
      // eslint-disable-next-line no-empty
    } catch {}
  }
  return placeholder ?? value;
}
